const types = {
	new_landing: 'new_landing'
};

const locale = {
	ru: {
		new_landing: 'новые лендинги'
	},
	en: {
		new_landing: 'new landings'
	},
	uk: {
		new_landing: 'new landings'
	},
	de: {
		new_landing: 'Neue Landings'
	},
	vi: {
		new_landing: 'new landings'
	},
	th: {
		new_landing: 'ร้านค้าออนไลน์ใหม่'
	}
};

module.exports = {
	enum: types,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/smart-notification-types.js